import React from 'react';
import MolLink from '../../Basepage/parts/Menu/MolLink';
import { GetEanSearch } from './Componnents/Ean_search';

export interface OrdersListModel {
  date_purchased;
  orders_id;
  mol_auftrag_id;
}

interface DataStr {
  readyInitBool: any;
  orderInfoDetails: [];
  eanInfo: any;
}
interface ReadyToSendProp {
  data: DataStr;
  apiBase: string;
}

interface ReadyToSendState {
  data: DataStr;
}

export default class ReadyToSend extends React.Component<
  ReadyToSendProp,
  ReadyToSendState
> {
  constructor(props) {
    super(props);
    this.state = { data: this.props.data };
  }
  render(): React.ReactNode {
    let GetEanSearch_local = GetEanSearch(
      '/konto/open',
      this.props.data.eanInfo,
    );
    let GetEanSearch_local_gui = GetEanSearch_local.gui;
    let eanSearchParam = GetEanSearch_local.eanSearchParam;
    let orderInfoDetails = this.state.data.orderInfoDetails ?? [];

    let orderInfoDetailsGroup: any = {};
    orderInfoDetails.forEach((item: any) => {
      let groupKey: string =
        item.maz_versand_einstellung_id + '_' + item.mol_kunde_adresse_id;
      if (orderInfoDetailsGroup[groupKey] == undefined) {
        orderInfoDetailsGroup[groupKey] = [];
      }
      orderInfoDetailsGroup[groupKey].push(item);
    });

    let groupKeys = Object.keys(orderInfoDetailsGroup);

    return (
      <div id="ReadyToSend">
        <div>
          <br />
          <br />
          Hier finden Sie die Artikel aus Ihren Bestellungen, die bei uns vor
          Ort und schon versandbereit sind.
          <br />
          <br />
          Unabhängig von Ihrem gewählten Versandtag oder Ihren Versandtagen,
          können Sie den schnellstmöglichen Versand dieser Artikel auslösen, in
          dem Sie auf „Versand veranlassen“ klicken.
          <br />
          <br />
          <br />
          <b>Bitte beachten Sie dabei unsere „Cut-off-Zeit" von 14:00 Uhr.</b>
          <br />
          <br />
        </div>

        {GetEanSearch_local_gui}
        <div id="messageContainer"></div>
        <table>
          <thead>
            <tr>
              <th>Bestellung</th>
              <th>Auftrag ID</th>
              <th>Bestellung ID</th>
              <th>EAN</th>
              <th>Bezeichnung</th>
              <th>Menge</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {groupKeys.map((group: any, index) => {
              let tage = ['Mo', 'Di', 'Mi', 'Do', 'Fr'];
              let tdAddress = (
                <td rowSpan={orderInfoDetailsGroup[group].length}>
                  <div
                    className="adressPickerCard selected"
                    style={{ position: 'relative' }}
                  >
                    <div className="adressPickerName">
                      {orderInfoDetailsGroup[group][0].vorname}{' '}
                      {orderInfoDetailsGroup[group][0].nachname}
                    </div>
                    <div className="adressPickerCompany">
                      {orderInfoDetailsGroup[group][0].zusatz}
                    </div>
                    <div>
                      {orderInfoDetailsGroup[group][0].strasse}{' '}
                      {orderInfoDetailsGroup[group][0].hausnummer}
                    </div>
                    <div>
                      {orderInfoDetailsGroup[group][0].plz}{' '}
                      {orderInfoDetailsGroup[group][0].ort}
                    </div>
                    <div className="adressPickerLiefertage">
                      Liefertage:{' '}
                      {orderInfoDetailsGroup[group][0].sammlung_shipmentdays
                        .split(',')
                        .map((day: string, i: number) => {
                          return <span key={i}>{tage[parseInt(day)]}</span>;
                        })
                        .reduce((prev: any, curr: any) => [prev, ', ', curr])}
                    </div>
                  </div>
                </td>
              );

              let tdStart = (
                <td rowSpan={orderInfoDetailsGroup[group].length}>
                  <div style={{ float: 'right' }}>
                    {orderInfoDetailsGroup[group][0].sammlung_bis_zum !=
                    null ? (
                      <>
                        <span>
                          Ihr Versandwunsch wurde an unsere Logistik
                          &uuml;bermittelt.
                          <br />
                          Wir versenden Ihre bestellung schnellstm&ouml;glich.
                        </span>
                      </>
                    ) : (
                      <a
                        style={{
                          float: 'right',
                          cursor: 'pointer',
                          backgroundColor: '#c20f0d',
                          color: 'white',
                          padding: '5px',
                        }}
                        onClick={() => {
                          let url =
                            this.props.apiBase +
                            '/Account.php?module=readyToSend&versand_einstellung_id=' +
                            orderInfoDetailsGroup[group][0]
                              .maz_versand_einstellung_id +
                            '&sendNow=1';
                          fetch(url, {
                            method: 'GET',
                            credentials: 'include',
                            headers: {
                              Accept: 'application/json',
                              'Content-Type': 'application/json',
                            },
                          })
                            .then((res) => res.json())
                            .then(
                              (result) => {
                                this.setState({
                                  data: result.body.readyToSend,
                                });
                              },
                              (error) => {},
                            );
                        }}
                      >
                        {' '}
                        Versand veranlassen
                      </a>
                    )}
                  </div>
                </td>
              );

              return orderInfoDetailsGroup[group].map((item: any, index2) => {
                let classNameRow = 'row' + (index % 2 == 1 ? ' mod2' : '');

                let link =
                  '/konto/mol_orders/' +
                  item.mol_auftrag_id +
                  '#pos_' +
                  item.mol_auftrag_position_id;

                return (
                  <tr
                    key={'row_' + item.mol_auftrag_id}
                    className={classNameRow}
                  >
                    {index2 == 0 ? tdAddress : null}
                    <td>
                      <MolLink to={link} href={link}>
                        {item.mol_auftrag_id}
                      </MolLink>
                    </td>
                    <td>{item.bestellreferenz}</td>
                    <td>{item.ean}</td>
                    <td>{item.pos_bezeichnung}</td>
                    <td>{+item.kommisionierung_menge}</td>
                    {index2 == 0 ? tdStart : null}
                  </tr>
                );
              });
            })}
          </tbody>
        </table>
      </div>
    );
  }
  componentDidMount(): void {
    this.setState({ data: this.props.data });
  }
}
